import type { Bar } from 'trading-view';

import { subscribeOnStream, unsubscribeFromStream } from './streaming';

type ReadPriceStreamProps = {
  onRead: (data: Bar) => void;
  ticker: string;

  id: string;
};
export const readPriceStream = ({
  ticker,
  onRead,
  id,
}: ReadPriceStreamProps) => {
  subscribeOnStream(
    {
      ticker,
    },
    '1', //doesnt matter in this case
    onRead,
    id,
    () => {},
    undefined,
    true,
  );

  return () => unsubscribeFromStream(id);
};
